// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4688":"9089d6d1","5654":"662fb8cb","9484":"77ffe6df"}[chunkId] + ".chunk.css";
};